import { Home, RotateCw, TriangleAlert } from 'lucide-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { Button } from '@/components/ui/Button';
import { buttonClass } from '@/components/ui/button-class';
import { EmptyState } from '@/components/ui/EmptyState';

/** Route-level error boundary: a render crash keeps the shell alive. */
export function RouteError() {
  const error = useRouteError();
  const isChunkError =
    error instanceof Error &&
    /Failed to fetch dynamically imported module|Importing a module script failed/i.test(error.message);
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unknown error';

  return (
    <EmptyState
      icon={TriangleAlert}
      className="min-h-[60vh]"
      title={isChunkError ? 'A new version of Biller is available' : 'This page crashed'}
      description={isChunkError ? 'Reload to get the latest console.' : detail}
      action={
        <Button variant="primary" icon={<RotateCw />} onClick={() => window.location.reload()}>
          Reload
        </Button>
      }
      secondary={
        <Link to="/" className={buttonClass('secondary')}>
          <Home /> Overview
        </Link>
      }
    />
  );
}

export function NotFoundPage() {
  return (
    <EmptyState
      className="min-h-[60vh]"
      title="Page not found"
      description="The link may be broken, or the page may have moved."
      action={
        <Link to="/" className={buttonClass('primary')}>
          Back to overview
        </Link>
      }
    />
  );
}

/** Neutral first paint for pages outside the console (no session to restore). */
export function BlankScreen() {
  return <div className="h-dvh bg-canvas" />;
}
